<template>
  <div>
    <h2>アカウント一覧をアップロード</h2>
    <div>アカウント一覧は <code>ID</code> <code>PW</code> <code>Group</code> の3つのカラムを含んだCSVファイルです。<br/>
      最初の行はヘッダーとして使われ、<code>ID</code> <code>PW</code> <code>Group</code> のカラムを含んでいる必要があります。<br/>
      <code>Group</code> は任意のグループ名を指定できますが <code>admin</code> と <code>root</code> は特別な意味を持っています。<br/>
      この管理画面にアクセスできるのは <code>admin</code> と <code>root</code> のみです。<br/>
      <code>admin</code> のアカウントはこの画面から登録可能ですが、<code>root</code> アカウントは登録できませんので、管理者にお問い合わせください。<br/>
      CSV ファイルの文字コードは UTF-8 である必要があります。<br/>
      CSV ファイルを Excel で編集すると、カラムの先頭の <code>0</code> が消えてしまうため、意図したものと違う <code>ID</code> <code>PW</code> になってしまう可能性があります。<br/>
      CSV ファイルの編集はテキストエディタを使用するか、<code>ID</code> <code>PW</code> の先頭の文字が <code>0</code> 以外の文字で始まるようにすることをお勧めします。<br/>
    </div>
    <v-btn raised color="primary" @click="$refs.uploadFile.click()">ファイルを選択</v-btn>
    <input type="file" ref="uploadFile" style="display:none" @change="uploadCsv"/>

    <v-dialog width="500" v-model="showUploadResult">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span v-if="uploadResultSuccess">アップロードしました</span>
          <span v-if="!uploadResultSuccess">エラーが発生しました</span>
        </v-card-title>
        <v-card-text v-text="uploadResultMessage">てすと</v-card-text>
        <v-card-text v-if="uploadResultIgnored.length > 0" v-text="uploadResultIgnored"
                     style="white-space: pre-wrap; margin-top:1em; color:darkorange"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="showUploadResult=false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- アップロード中のプログレスバー -->
    <LoadingOverlay v-if="progress"/>
  </div>
</template>

<script>
import {getAuthToken, sessionTimeouted} from '@/lib/common'
import {postAccounts} from '@/lib/api'
import LoadingOverlay from '@/components/LoadingOverlay'

export default {
  name: 'Admin',
  components: {LoadingOverlay},
  data: function () {
    return {
      progress: false,
      uploadResultSuccess: false,
      uploadResultMessage: '',
      uploadResultIgnored: '',
      showUploadResult: false
    }
  },
  methods: {
    // ファイルをアップロード
    uploadCsv: function (e) {
      if (e.target.files.length > 0) {
        const file = e.target.files[0]
        console.log(`uploadCsv ${file}`)
        this.progress = true
        this.uploadResultMessage = null
        postAccounts(getAuthToken(), file)
          .then((response) => {
            this.progress = false
            let message = `登録済みのアカウントは ${response.data.count} 件です。`
            if (response.data.warnings) {
              this.uploadResultIgnored = response.data.warnings
            }
            this.showMessage(message)
          })
          .catch((error) => {
            console.log(`アップロードエラー ${error}`)
            this.progress = false
            if (error.response) {
              let message = error.response.data.message || error.message
              if (error.response.data.line) {
                message += error.response.data.line
              }
              this.showError(message)
            } else if (error.request) {
              this.showError(error.request)
            } else {
              this.showError(error.message)
            }
            if (error.response.status === 401) {
              sessionTimeouted(this)
            }
          })
      }
    },
    showMessage: function (message) {
      this.uploadResultSuccess = true
      this.uploadResultMessage = message
      this.showUploadResult = true
    },
    showError: function (message) {
      this.uploadResultSuccess = false
      this.uploadResultMessage = message
      this.uploadResultIgnored = ''
      this.showUploadResult = true
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/UploadAccounts.vue